import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { UniqaSyncJobAuditLogEntryResponse } from '../definitions/uniqa-sync-job-audit-log-entry-response.interface';

@Injectable()
export class GetUniqaSyncJobAuditService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getAudit(id: string): Observable<Array<UniqaSyncJobAuditLogEntryResponse>> {
    const url = `${this.configService.config.rest.apiV2Url}/uniqa-sync-jobs/${id}/audit`;

    return this.client.get<Array<UniqaSyncJobAuditLogEntryResponse>>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
